import { Button, Modal } from "react-bootstrap";
import "./MsgModal.style.scss";
import { useTranslation } from "react-i18next";

interface IMsgModalProps {
  msgModalTitle: string;
  msgModalBody: string;
  showMsgModal: boolean;
  nextButton: () => void;
}
const MsgModal = ({
  msgModalTitle,
  msgModalBody,
  showMsgModal,
  nextButton,
}: IMsgModalProps) => {
  const { t } = useTranslation();
  return (
    <Modal
      show={showMsgModal}
      onHide={() => nextButton()}
      className="msg-modal"
      style={{ opacity: 1 }}
    >
      <Modal.Header closeButton>
        <h4>{msgModalTitle}</h4>
      </Modal.Header>
      <Modal.Body>
        <div className="ok-sign"></div>
        <p className="text text--14">{msgModalBody}</p>
        <Button className="btn" onClick={nextButton}>
          {t("common.okBtn")}
        </Button>
      </Modal.Body>
      {/* <Modal.Footer>
      </Modal.Footer> */}
    </Modal>
  );
};

export default MsgModal;
